import { render, staticRenderFns } from "./equityFormPage.vue?vue&type=template&id=327f8cf4&scoped=true"
import script from "./equityFormPage.vue?vue&type=script&lang=js"
export * from "./equityFormPage.vue?vue&type=script&lang=js"
import style0 from "./equityFormPage.vue?vue&type=style&index=0&id=327f8cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f8cf4",
  null
  
)

export default component.exports